<template>
    <div>
        <TitleImage image="notices" title="Panel de control"/>
        <div class="spacer"></div>
        <div class="col-md-9 col-sm-12 container">
            <div v-if="loader"></div>
            <div v-else>
                <div v-if="searchAllow('messages')">
                    <h3 class="mt-3">
                        Mensajes de contacto
                        <span class="badge badge-warning" v-if="!unreadMessages.length">{{unreadMessages}} sin leer</span>
                    </h3>
                    <RouterLink :to="{name: 'Messages'}" class="btn btn-primary w-100 mt-2">Ver mensajes de contacto</RouterLink>
                    <div class="spacer"></div>
                </div>

                <div v-if="searchAllow('school')" class="mb-4">
                    <h3 class="mt-3">Información de la escuela</h3>
                    <RouterLink :to="{name: 'EditSchool'}" class="btn btn-primary w-100">Editar información de la escuela</RouterLink>
                    <div class="spacer"></div>
                </div>

                <div v-if="searchAllow('notices')">
                    <RouterLink :to="{name: 'Publish'}" class="btn btn-primary w-100">Publicar nueva noticia</RouterLink>
                    <h3 class="mt-3">Todas las noticias</h3>
                    <NoticesDashboard />
                    <div class="spacer"></div>
                </div>

                <div v-if="searchAllow('books')">
                    <RouterLink :to="{name: 'PublishBook'}" class="btn btn-primary w-100">Publicar nuevo libro</RouterLink>
                    <h3 class="mt-3">Biblioteca</h3>
                    <BooksDashboard />
                    <div class="spacer"></div>
                </div>

                <div v-if="searchAllow('techniques')">
                    <h3 class="mt-3">Editar tecnicaturas</h3>
                    <Techniques :edit="true" />
                    <div class="spacer"></div>
                </div>

                <div v-if="searchAllow('team')">
                    <h3 class="mt-3">Editar equipo</h3>
                    <RouterLink :to="{name: 'EditTeam'}" class="btn btn-primary w-100">Editar equipo</RouterLink>
                    <div class="spacer"></div>
                </div>






            </div>
            <div class="spacer-large"></div>

        </div>
    </div>
</template>

<script>
import TitleImage from '@/components/TitleImage'
import NoticesDashboard from '@/components/admin/NoticesDashboard'
import BooksDashboard from '@/components/admin/BooksDashboard'
import Techniques from '@/components/Techniques'
export default {
    components:{
        TitleImage,
        NoticesDashboard,
        BooksDashboard,
        Techniques
    },
    name: 'Dashboard',
    data(){
        return{
            loader: true
        }
    },
    async created(){
        await this.$store.dispatch('user/getAllows')
        if(this.searchAllow('messages')){
            this.$store.dispatch('message/getMessages')
        }
        this.loader = false
    },
    methods:{
        searchAllow(allowType){
            return this.allows.allow.find(allow => allow == allowType)
        }
    },
    computed:{
        allows(){
            return this.$store.state.user.allows
        },
        unreadMessages(){
            return this.$store.state.message.messages.filter(message => message.read == null).length
        }
    }

}
</script>